import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetTeamStake -    获取押量总量
 */
const useGetTeamStake = () => {
    const { address, contractEvm: { RegularStaking } } = useConnectWallet();

    // 押量总量
    const [teamStake, setTeamStake] = useState<bigint>(BigInt(0));
    // loading
    const [teamStakeLod, setLoading] = useState(false);


    const getTeamStake = useCallback(async () => {
        if (!RegularStaking || !address) return;

        try {
            setLoading(true);
            const res = await RegularStaking.teamStake(address);
            setTeamStake(res);

        } catch (error) {
            console.log('useGetTeamStake error:', error);
        } finally {
            setLoading(false);
        }
    }, [RegularStaking, address]);

    useEffect(() => {
        getTeamStake();
    }, [getTeamStake]);

    return {
        teamStake,
        teamStakeLod,
        getTeamStake
    };
};

export default useGetTeamStake;
